import { render } from "./AutoScaleUpPolicyTab.vue?vue&type=template&id=bb5db9c8&scoped=true"
import script from "./AutoScaleUpPolicyTab.vue?vue&type=script&lang=js"
export * from "./AutoScaleUpPolicyTab.vue?vue&type=script&lang=js"

import "./AutoScaleUpPolicyTab.vue?vue&type=style&index=0&id=bb5db9c8&scoped=true&lang=scss"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb5db9c8"]])

export default __exports__